// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseCollapse_wrapper_2QCyq","header":"BaseCollapse_header_3tTVr","header-icon":"BaseCollapse_header-icon_1xTIv","content":"BaseCollapse_content_3DlO_"};